<template>
<div class="chapter">
<div class="inner_page">
<p class="western8" id="calibre_pb_5"> <br class="calibre2"/></p>
<p class="western7"> <br class="calibre2"/></p>
<p class="western7">We’ve grown, you and I,</p>
<p class="western7">In different ways,</p>
<p class="western7">On different days,</p>
<p class="western7">Isn’t it lonely together?</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western9">Deborah D. Moore</p>
<p class="western9"> <br class="calibre2"/></p>
<p class="western9"> <br class="calibre2"/></p>
<p class="western10"> <br class="calibre2"/></p>
<p class="western9"> <br class="calibre2"/></p>
<p class="western9"> <br class="calibre2"/></p>
<p class="western9"> <br class="calibre2"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_005.vue?4b46b1b0